// radius overrides the corner radius (mobile cards use a per-deck value from Figma).
const AiWorkshopCard = ({ illustration, radius }) => (
  <div
    className="relative w-full h-full sm:max-w-[588px] sm:rounded-[20px] overflow-hidden"
    style={radius ? { borderRadius: `${radius}px` } : undefined}
  >
    {illustration && (
      <img
        src={illustration}
        alt=""
        className="w-full h-full object-cover pointer-events-none select-none"
      />
    )}
  </div>
);

export default AiWorkshopCard;
